"use client";

import { FinancingVideoShowcase } from "@/components/blocks/financing-video-showcase";
import type { FinancingVideoEpisode } from "@/components/blocks/financing-video-showcase";
import { EstablishedContentSection } from "@/components/established/section-shell";
import { cn } from "@/lib/utils";

export interface EstablishedVideoEpisode {
  id: string;
  title: string;
  subtitle: string;
  href: string;
  thumbnailUrl: string;
  thumbnailAlt: string;
}

interface EstablishedVideoCarouselProps {
  title: string;
  ctaLabel: string;
  ctaHref: string;
  episodes: readonly EstablishedVideoEpisode[];
  className?: string;
}

function toFinancingEpisodes(
  episodes: readonly EstablishedVideoEpisode[]
): FinancingVideoEpisode[] {
  return episodes.map((episode) => ({
    id: episode.id,
    title: episode.title,
    storyLabel: episode.subtitle,
    href: episode.href,
    thumbnailUrl: episode.thumbnailUrl,
    thumbnailAlt: episode.thumbnailAlt,
  }));
}

/** Customer-stories carousel — Figma 8301:74848. */
export function EstablishedVideoCarousel({
  title,
  ctaLabel,
  ctaHref,
  episodes,
  className,
}: EstablishedVideoCarouselProps) {
  return (
    <EstablishedContentSection
      dataTestId="established-video-carousel-section"
      className={cn("py-8 md:py-16 lg:py-20", className)}
    >
      <FinancingVideoShowcase
        title={title}
        ctaLabel={ctaLabel}
        ctaHref={ctaHref}
        episodes={toFinancingEpisodes(episodes)}
        dataTestId="established-video-carousel"
      />
    </EstablishedContentSection>
  );
}
